<!--寒假班车-->
<template>
  <div class="scj">
    <div class="scj-head">
      <van-icon
        name="arrow-left"
        size="17"
        class="scj-head-left"
        color="#33639e"
        @click="handleBackClick"
      ></van-icon>
      <span class="scj-head-text">寒假班车</span>
    </div>
    <div class="scj-body">
      <img class="scj-body-item" src="@/assets/image/hjbc/1737006709469.png" alt="">
      <img class="scj-body-item" src="@/assets/image/hjbc/1737006734371.png" alt="">
      <img class="scj-body-item" src="@/assets/image/hjbc/1737006755908.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleBackClick() {
      window.history.go(-1)
    }
  }
}

</script>
<style lang="scss" scoped>
.scj {
  height: 100%;
  &-head {
    height: 40px;
    display: flex;
    &-left {
      padding: 10px 0 0 10px;
      box-sizing: border-box;
    }
    &-text {
      font-size: 18px;
      color: #33639e;
      box-sizing: border-box;
      padding-left: 7px;
      padding-top: 10px;
      font-weight: 600;
      letter-spacing: 2px;
    }
    &-right {
      position: absolute;
      right: 20px;
      top: 13px;
      letter-spacing: 1px;
      color: #33639e;
      font-weight: 600;
    }
  }
  &-body {
    height: calc(100% - 40px);
    background-color: #ececec;
    overflow: auto;
    &-item:first-child{
      margin-top: 10px;
    }
    &-item{
      margin-bottom: 10px;
      display: block;
      width: 100%;
    }
  }
}
</style>
